import request from '@/utils/request'
import type { TrainNetworkQuery, PageResult } from '@/types/train-netWork'
import { getEntryInfo } from '@/utils/index'

export function GetTrainNetworkpoints(query: TrainNetworkQuery): Promise<PageResult> {
  const url = getEntryInfo().isFromMemberUnToken
    ? '/api/external/applets/train/train_station/select_by_withdist'
    : '/api/applets/train/train_station/select_by_withdist'
  return request.get(url, { params: query })
}
